// Platform-wide roles (public.roles.name) — synced into JWT app_metadata.roles[] via auth_hooks.sql
export enum PlatformRoleEnum {
  ADMIN = "admin",
  BUSINESS_OWNER = "business_owner",
  CUSTOMER = "member",
}

// Per-merchant role inside a tenant (public.merchant_users.role_in_merchant)
export enum MerchantRoleEnum {
  OWNER = "owner",
  STAFF = "staff",
}
